import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Chip, IconButton, Paper, Skeleton, Typography } from '@mui/material';

const ROLE_CONFIG = {
  super:   { label: 'Super Admin',    bg: '#4527a0', color: '#fff' },
  admin:   { label: 'Administrador',  bg: '#1565c0', color: '#fff' },
  visitor: { label: 'Visitante',      bg: '#e65100', color: '#fff' },
};

export const UserCard = ({ primary, secondary, role, location, onClickDelete, onClickUpdate, isLoading, isHidden }) => {
  if (isLoading) {
    return (
      <Paper variant="outlined" sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, mb: 1 }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flex: 1 }}>
          <Skeleton width="55%" height={20} />
          <Skeleton width="38%" height={16} />
        </Box>
      </Paper>
    );
  }

  const roleConfig = ROLE_CONFIG[role];

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 2,
        mb: 1,
        bgcolor: 'background.paper',
      }}
    >
      <AccountCircleIcon sx={{ fontSize: 40, color: 'grey.400', flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="body1" fontWeight="bold" noWrap>
            {primary}
          </Typography>
          {roleConfig && (
            <Chip
              label={roleConfig.label}
              size="small"
              sx={{
                bgcolor: roleConfig.bg,
                color: roleConfig.color,
                fontWeight: 600,
                fontSize: '0.7rem',
                height: 20,
              }}
            />
          )}
        </Box>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {secondary}
        </Typography>
        {location && (
          <Typography variant="caption" sx={{ color: 'text.disabled' }} noWrap>
            {location}
          </Typography>
        )}
      </Box>
      {!isHidden && (
        <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
          <IconButton size="small" onClick={onClickUpdate} sx={{ color: 'primary.main' }}>
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={onClickDelete} sx={{ color: 'error.main' }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Paper>
  );
};
